import { useEffect } from 'react';

const useFavicon = (faviconUrl) => {
  useEffect(() => {
    if (faviconUrl) {
      // Remove existing favicon links
      const existingFavicons = document.querySelectorAll('link[rel*="icon"]');
      existingFavicons.forEach(link => link.remove());

      // Create new favicon link
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      link.href = faviconUrl;
      
      // Add to document head
      document.head.appendChild(link);
    }
  }, [faviconUrl]);
};

export default useFavicon;